import React, { useState,useEffect } from "react";
import { toast } from 'react-toastify';
import ColorPicker from "../../../components/ColorPicker";
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";

const AppearanceTab = ({ updateChatTabData,chatTabData }) => {
    const [chatWindowNameColor, setChatWindowNameColor] = useState(chatTabData.chat_window_name_color);
    const [chatWindowCaptionColor, setChatWindowCaptionColor] = useState(chatTabData.chat_window_caption_color);
    const [bubbleBackgroundColor, setBubbleBackgroundColor] = useState(chatTabData.bubble_background_color);
    const [bubbleIconColor, setBubbleIconColor] = useState(chatTabData.bubble_icon_color);
    const [bubbleNotificationBadgeColor, setbubbleNotificationBadgeColor] = useState(chatTabData.notification_badge_color);
    const [headerBackgroundColor, setHeaderBackgroundColor] = useState(chatTabData.header_background_color);
    const [userOnlineStatusColor, setUserOnlineStatusColor] = useState(chatTabData.online_status_color);
    const [chatWallpaperColor, setChatWallpaperColor] = useState(chatTabData.chat_wallpaper_color);
    const [messageBackgroundColor, setMessageBackgroundColor] = useState(chatTabData.message_background_color);
    const [buttonColor, setButtonColor] = useState(chatTabData.button_color);
    const [activeAppearanceElementsTab, setActiveAppearanceElementsTab] = useState("main");
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(chatTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(chatTabData.custom_js);

    // Handlers Chat Window Name Color Change
    const handleChatWindowNameColorChange = (color) => {
        setChatWindowNameColor(color.hex);
        updateChatTabData("chat_window_name_color", color.hex);
    };

    // Handlers Chat Window Caption Color Change
    const handleChatWindowCaptionColorChange = (color) => {
        setChatWindowCaptionColor(color.hex);
        updateChatTabData("chat_window_caption_color", color.hex);
    };

    // Handlers Bubble Background Color Change
    const handleBubbleBackgroundColorChange = (color) => {
        setBubbleBackgroundColor(color.hex);
        updateChatTabData("bubble_background_color", color.hex);
    };

    // Handlers Bubble Icon Color Change
    const handleBubbleIconColorChange = (color) => {
        setBubbleIconColor(color.hex);
        updateChatTabData("bubble_icon_color", color.hex);
    };
    // Handlers Bubble Icon Color Change
    const handleBubbleNotificationBadgeColorChange = (color) => {
        setbubbleNotificationBadgeColor(color.hex);
        updateChatTabData("notification_badge_color", color.hex);
    };

    // Handlers Header Background Color Change
    const handleHeaderBackgroundColorChange = (color) => {
        setHeaderBackgroundColor(color.hex);
        updateChatTabData("header_background_color", color.hex);
    };


    // Handlers Header Background Color Change
    const handleUserOnlineStatusColorChange = (color) => {
        setUserOnlineStatusColor(color.hex);
        updateChatTabData("online_status_color", color.hex);
    };

    // Handlers Chat Wallpaper Color Change
    const handleChatWallpaperColorChange = (color) => {
        setChatWallpaperColor(color.hex);
        updateChatTabData("chat_wallpaper_color", color.hex);
    };

    // Handlers Message Background Color Change
    const handleMessageBackgroundColorChange = (color) => {
        setMessageBackgroundColor(color.hex);
        updateChatTabData("message_background_color", color.hex);
    };

    // Handlers Button Color Change
    const handleButtonColorChange = (color) => {
        setButtonColor(color.hex);
        updateChatTabData("button_color", color.hex);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateChatTabData("custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateChatTabData("custom_js", code);
    };

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => {
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="whats-app-side-baar-appearance-tab">
            {activeAppearanceElementsTab === "main" && (
                <>
                <span>Appearance</span>
                <div className="side-baar-box-header">
                    <div className="box-header-row">
                        <span>Font</span>
                        <em>Default</em>
                    </div>
                    <div className="box-header-row">
                        <span>Window Name Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={chatWindowNameColor} setColor={setChatWindowNameColor} onChangeComplete={handleChatWindowNameColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Window Name Caption Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={chatWindowCaptionColor} setColor={setChatWindowCaptionColor} onChangeComplete={handleChatWindowCaptionColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Bubble Background Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={bubbleBackgroundColor} setColor={setBubbleBackgroundColor} onChangeComplete={handleBubbleBackgroundColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Bubble Icon Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={bubbleIconColor} setColor={setBubbleIconColor} onChangeComplete={handleBubbleIconColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Bubble Notification Badge Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={bubbleNotificationBadgeColor} setColor={setbubbleNotificationBadgeColor} onChangeComplete={handleBubbleNotificationBadgeColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Header Background Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={headerBackgroundColor} setColor={setHeaderBackgroundColor} onChangeComplete={handleHeaderBackgroundColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>User Online Status Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={userOnlineStatusColor} setColor={setUserOnlineStatusColor} onChangeComplete={handleUserOnlineStatusColorChange}/>
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Chat Wallpaper</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={chatWallpaperColor} setColor={setChatWallpaperColor} onChangeComplete={handleChatWallpaperColorChange}/>
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Message Background Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={messageBackgroundColor} setColor={setMessageBackgroundColor} onChangeComplete={handleMessageBackgroundColorChange}/>
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Button Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={buttonColor} setColor={setButtonColor} onChangeComplete={handleButtonColorChange}/>
                        </div>
                    </div>
                </div>
                <div className="side-baar-box-header">
                    <div className="box-header-row" onClick={() => setActiveAppearanceElementsTab("custom_css")}>
                        <span>Custom CSS</span>
                        <em><button><i className="fa fa-angle-right" aria-hidden="true"></i></button></em>
                    </div>
                    <div className="box-header-row" onClick={() => setActiveAppearanceElementsTab("custom_js")}>
                        <span>Custom JS</span>
                        <em><button><i className="fa fa-angle-right" aria-hidden="true"></i></button></em>
                    </div>
                </div>
                </>
            )}

            {activeAppearanceElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AppearanceTab;